function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M9,45h32c2.211,0,4-1.789,4-4V9c0-2.211-1.789-4-4-4H9C6.789,5,5,6.789,5,9v32C5,43.211,6.789,45,9,45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M30.058,11h-4.016c0,0-0.042,19.498-0.042,19.594c0,2.404-2.123,4.298-4.527,4.298s-4.352-1.948-4.352-4.352s1.948-4.352,4.352-4.352c0.181,0,0.352,0.032,0.527,0.053v-4.202c-0.175-0.011-0.349-0.027-0.527-0.027c-4.709,0-8.527,3.818-8.527,8.527s3.818,8.527,8.527,8.527S30,35.249,30,30.54c0-0.102,0-6.188,0-11.537c1.341,2.04,3.646,3.388,6.269,3.388c0.233,0,0.462-0.014,0.69-0.035v-4.671C33.335,17.425,30.435,14.591,30.058,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon-tiktok.889a90dbd79ccf7f5c42c65f99f35d5f.svg";
export { ForwardRef as ReactComponent };